module.exports = __webpack_public_path__ + "img/hr-data.45cc8ee6.png";